import type { GuardianRelationship } from "elephant-web/gql";
import {
  PhoneOwnershipRadioOptions,
  phoneOwnershipToContactPointOwnerMap,
} from "../../new/patient/_lib/sections/phone-ownership";

const coerceToBoolean = (
  value: boolean | string | null | undefined,
): boolean => {
  if (typeof value === "string") {
    return value.toLowerCase() === "true";
  }
  return value ?? false;
};

export const mapGuardianToPatientGuardian = ({
  guardianData,
  user,
  currentTime,
  generateId,
}: {
  guardianData:
    | {
        fullName?: string | null;
        phone?: {
          number?: string;
          ownership?: string;
        } | null;
        patientId?: string | null;
        relationship?: string;
        consents?: {
          healthcareComms?: boolean | null;
          marketingComms?: boolean | null;
        } | null;
      }
    | null
    | undefined;
  user: { id: string };
  currentTime: string; // ISO string
  generateId: () => string;
}) => {
  if (!guardianData) {
    return null;
  }

  return [
    {
      id: generateId(),
      fullName: guardianData.fullName ?? null,
      phone:
        guardianData.phone?.number &&
        guardianData.phone.ownership !== PhoneOwnershipRadioOptions.None
          ? {
              number: guardianData.phone.number,
              ownership:
                phoneOwnershipToContactPointOwnerMap[
                  guardianData.phone.ownership
                ],
            }
          : null,
      patientId: guardianData.patientId ?? null,
      relationship: guardianData.relationship as GuardianRelationship,
      consents: {
        healthcareComms: {
          value: coerceToBoolean(guardianData.consents?.healthcareComms),
          providedAt: currentTime,
        },
        marketingComms: {
          value: coerceToBoolean(guardianData.consents?.marketingComms),
          providedAt: currentTime,
        },
      },
      meta: {
        createdAt: currentTime,
        createdByUserId: user.id,
        updatedAt: currentTime,
        updatedByUserId: user.id,
        deleted: false,
      },
    },
  ];
};
